var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMistral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 135,
    viewBox: "0 0 191 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3221 0H27.1531V27.0892H54.3221V0Z",
    fill: "#FFD800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.984 0H135.815V27.0892H162.984V0Z",
    fill: "#FFD800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4823 27.0913H27.1531V54.1805H81.4823V27.0913Z",
    fill: "#FFAF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.99 27.0913H108.661V54.1805H162.99V27.0913Z",
    fill: "#FFAF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.972 54.168H27.1531V81.2572H162.972V54.168Z",
    fill: "#FF8205"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3221 81.2593H27.1531V108.349H54.3221V81.2593Z",
    fill: "#FA500F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.661 81.2593H81.4917V108.349H108.661V81.2593Z",
    fill: "#FA500F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.984 81.2593H135.815V108.349H162.984V81.2593Z",
    fill: "#FA500F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4879 108.339H-0.00146484V135.429H81.4879V108.339Z",
    fill: "#E10500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.159 108.339H108.661V135.429H190.159V108.339Z",
    fill: "#E10500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190.141,
    height: 135,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMistral);
export default __webpack_public_path__ + "static/media/mistral.4a7c8a0c5a72feeb87547a7fd0b84ec5.svg";
export { ForwardRef as ReactComponent };